/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

/**
 * Controller for gallery.
 */
export default class extends Controller {
  /**
   * Connect gallery.
   */
  connect() {
    this.lg = lightGallery(this.element, {
      selector: '[data-video]',
      getCaptionFromTitleOrAlt: false,
      download: false,
      plugins: [lgVideo],
      licenseKey: '00000000-00000000-00000000-00000000',
    });
  }

  /**
   * Disconnect gallery.
   */
  disconnect() {
    this.lg.destroy();
  }
}
